import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOKS, SERVICEBOOK_INIT_PATCH, SERVICEBOOK_PATCH_SERVICEBOOK, SERVICEBOOK_SET_SEARCH_PARAMS, SERVICEBOOK_SET_SERVICEBOOKS } from '../../../store/service-book';
import InfiniteLoading from "vue-infinite-loading";
import { IServiceBook } from '../../../models/service-book/service-book.model';
import { eventBus } from '../../../main';
import { IPatchServiceBook, IServiceBookSearchParams } from '../../../store/service-book/service-book-state.store';
import {DateTimeHelper} from '../../../utils/DateTimeHelper.util'
import { TranslateResult } from 'vue-i18n';
import { BlockService } from '../../../services';
import { watch } from 'fs';

const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
@Component({
  name:'ServiceBookHome',
  components: {
    InfiniteLoading,
    'service-book-modal': async () => import('../components/service-book-modal/ServiceBookModal.vue'),
  }
})
class ServiceBookHome extends Vue {

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOKS)
  storeGetServiceBooks: (infiniteHandlerState:any) => Promise<IServiceBook[]>

  @ServiceBookStore.Action(SERVICEBOOK_PATCH_SERVICEBOOK)
  storePatchServiceBook: (payload:{id:string,apartment?:any, fk_apartment?:number}) => Promise<any>

  @ServiceBookStore.Mutation(SERVICEBOOK_INIT_PATCH)
  storeInitServiceBookPatchData: (payload: any) => void;

  @ServiceBookStore.Getter serviceBooks: IServiceBook[];
  @ServiceBookStore.Getter isLoading: boolean;
  @ServiceBookStore.Getter patchData:IPatchServiceBook

  @ServiceBookStore.Mutation(SERVICEBOOK_SET_SERVICEBOOKS)
  storeSetServiceBooks: (serviceBooks:IServiceBook[]) => void

  @ServiceBookStore.Mutation(SERVICEBOOK_SET_SEARCH_PARAMS)
  storeServiceBookSearchParameter: (parameter: IServiceBookSearchParams) => void;
  @ServiceBookStore.Getter searchParams:IServiceBookSearchParams



  mouseOverIndex:number|null
  // === service book
  serviceBookId:number
  serviceBookNumber:number
  dtServiceBookModalVisible:boolean
  isUpdateAction:boolean
  dtIsRecording: boolean;
  dtErrorModalVisible: boolean;
  dtError: any;
  dtBlocks:any[]
  BlockService:BlockService
  orderByItems:any[]
  orderBy:any

  constructor() {
    super();
    this.mouseOverIndex = null
    // === service book
    this.dtServiceBookModalVisible = false
    this.isUpdateAction = false
    this.dtIsRecording = false
    this.dtErrorModalVisible = false
    this.dtError = null
    this.serviceBookId = 0
    this.serviceBookNumber = 0
    this.dtBlocks = []
    this.BlockService = new BlockService()
    this.orderBy = {
      value:'number',
      text:'Numéro du carnet',
      ascending:true,
    }
    this.orderByItems = [
      {
        value:'number',
        text:'Numéro du carnet',
        ascending:true,
      },
      {
        value:'createdAt',
        text:'Date de création',
        ascending:true,
      },
      {
        value:'activatedAt',
        text:'Date d\'activation',
        ascending:true,
      },
      {
        value:'expireAt',
        text:'Date d\'expiration',
        ascending:true,
      }
    ]

  }


  get lblSetting() {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/service-book').default,
    }
  }

  beforeMount()
  {

  }
  created() {
    if(this.$route.query.state && (this.$route.query.state ==='free' || this.$route.query.state === 'used') ){
      this.searchParams.free = this.$route.query.state === 'free' ? true : false; 
    }
  }


  @Watch('searchParams.free')
  handleFreeStateChanged(value:boolean)
  {
    if(value)
    {
      this.orderByItems = [
        {
          value:'number',
          text:'Numéro du carnet',
          ascending:true,
        },
        {
          value:'createdAt',
          text:'Date de création',
          ascending:true,
        }
      ]
    } else {
      this.orderByItems = [
        {
          value:'number',
          text:'Numéro du carnet',
          ascending:true,
        },
        {
          value:'createdAt',
          text:'Date de création',
          ascending:true,
        },
        {
          value:'activatedAt',
          text:'Date d\'activation',
          ascending:true,
        },
        {
          value:'expireAt',
          text:'Date d\'expiration',
          ascending:true,
        }
      ]
    }
  }


  mounted()
  {
    eventBus.$on('RELOAD_SERVICEBOOK',()=>{
      this.reloadServiceBooks()
    })
    this.getData()
  }

  getData():Promise<any>
  {
    return new Promise(async(resolve)=>{
      try {
        const blocksArray = await this.BlockService.getBlocks({has_child:false},true)
        this.dtBlocks = blocksArray.data
        resolve(true)
      } catch (error) {
        console.log(error)
      }
    })
  }

  handleOrderBy(value:any)
  {
    console.log(value)
    if(value)
    {
      this.orderByItems.map(item=>{
        if(item.value===value.value)
        {
          item.ascending = !value.ascending
        }
      })
      this.orderBy = value
      switch(this.orderBy.value)
      {
        case "number":
          this.storeServiceBookSearchParameter({
            $sort:{number:this.orderBy.ascending ? 1:-1}
          })
          break;
        case "createdAt":
          this.storeServiceBookSearchParameter({
            $sort:{createdAt:this.orderBy.ascending ? 1:-1}
          })
          break;
        case "activatedAt":
          this.storeServiceBookSearchParameter({
            $sort:{activatedAt:this.orderBy.ascending ? 1:-1}
          })
          break;
        case "expireAt":
          this.storeServiceBookSearchParameter({
            $sort:{expireAt:this.orderBy.ascending ? 1:-1}
          })
          break;
      }
      this.reloadServiceBooks()
    }
  }


  async handleGetBlocks(key: string, cb:Function) {
    //this.isLoading = true
    try {
      const blocksArray = await this.BlockService.getBlocks({key, has_child:false},true)
      this.dtBlocks = blocksArray.data
      //this.isLoading = false
      cb((blocksArray.data || []).map(x => {
        const {line1, line2, zip_code, city, country} = x.address
        const array = [line1, line2, zip_code, city, country]
        const filtred = array.filter(n => n)
        return {
          value: x.id,
          text: x.name + " : " +filtred.join(', '),
          ...x
        }
      }))
    } catch (error) {
      console.log(error)
      //this.isLoading = false
    }
  }

  get block() {
    return this.searchParams.block
  }

  set block(value:any) {
    this.storeServiceBookSearchParameter({block:value ? value.id : null})
  }

  async handleChangeBlock(value) {
    console.log(value)
    this.reloadServiceBooks()
  }


  get coBlocks() {
    return this.dtBlocks.map(x => {
        const {line1, line2, zip_code, city, country} = x.address
        const array = [line1, line2, zip_code, city, country]
        const filtred = array.filter(n => n)
        return {
          value: x.id,
          text: x.name,//x.name + " : " +filtred.join(', '),
          ...x
        }
    });
  }




  reloadServiceBooks()
  {
    const infiniteLoadingRef:any = this.$refs.infiniteLoadingRef
    this.storeSetServiceBooks([])
    infiniteLoadingRef.stateChanger.reset()
  }

  beforeDestroy()
  {
    eventBus.$off('RELOAD_SERVICEBOOK')
    this.storeSetServiceBooks([])
    this.storeServiceBookSearchParameter({
      free: false,
      showDetails: true
    })
  }

  infiniteHandler(infiniteHandlerState:any) {
    this.storeGetServiceBooks(infiniteHandlerState)
  }

  getOwner(item:any)
  {
    if(!item.owner) return null
    return `${item.owner.firstname} ${item.owner.lastname}`
  }

  hoverOver(index:number|null)
  {
    this.mouseOverIndex = index
  }

  parseDate(date:string) {
    return DateTimeHelper.parseDate(date)
  }

  associateApartment()
  {
    console.log('associateApartment')
  }

  goToDetails(id:number)
  {
    this.$router.push({name:'service_book_details',params:{id:id.toString()}})
  }

  getAddress(item:any):string {
    const {line1, line2, zip_code, city, country} = item
    const array = [line1, line2, zip_code, city, country]
    const filtred = array.filter(n => n)
    return filtred.join(', ')
  }

  async handleSaveServiceBook()
  {
    //this.dtIsRecording = true;
    //console.log(this.patchData)
    const patchObject = {...this.patchData}
    // remove Null properties from patchObject
    Object.keys(patchObject).forEach(key => {
      if (patchObject[key] === null) {
        delete patchObject[key];
      }
    });

    // remove address if fk_apartment_block
    if(patchObject.fk_apartment_block) delete patchObject.address
    console.log(patchObject)
    this.dtIsRecording = true

    try {

      const payload:{id:string, fk_apartment?:number,apartment?:any} = {
        id:this.serviceBookId.toString()
      }

      if(patchObject.fk_apartment) {
        payload.fk_apartment = patchObject.fk_apartment
      } else {
        payload.apartment = patchObject
      }

      console.log(payload)

      const patch = await this.storePatchServiceBook(payload)
      console.log("Patch response = ", patch)
      this.dtIsRecording = false
      this.dtServiceBookModalVisible = false
      this.storeInitServiceBookPatchData({})
      this.reloadServiceBooks()
    } catch (error) {
      console.log(error)
      this.dtIsRecording = false
      this.dtServiceBookModalVisible = false
      this.storeInitServiceBookPatchData({})
      this.reloadServiceBooks()
    }
  }

  get buttonText() : TranslateResult {
    return this.isUpdateAction ? this.$t(this.lblSetting.btnUpdate) : this.$t(this.lblSetting.blockSave)
  }

  get serviceBookMaxWidth(): string {
    return `${document.body.clientWidth * 0.9}px`
  }

  handleClose(){
    console.log('close modal')
    this.storeInitServiceBookPatchData({})
  }

  handleBeforeModalClose() {
    console.log('before close modal')
  }

  get serviceBookModalTitle() : TranslateResult {
    return this.isUpdateAction ? 'Modifier' : `Associer le carnet d'entretien #${this.serviceBookNumber} à un lot`
  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null;
  }

  openServiceBookModalFor(item:any)
  {
    this.serviceBookId = item.id
    this.serviceBookNumber = item.number
    this.dtServiceBookModalVisible = true
  }

}

export default ServiceBookHome;



// WEBPACK FOOTER //
// ./src/containers/service-book/home/index.ts